import { Skeleton } from "antd";

export const AntSekelton = (props) => {
  return <Skeleton {...props} active />;
};

AntSekelton.Button = (props) => {
  return <Skeleton.Button {...props} active />;
};

AntSekelton.Avatar = (props) => {
  return <Skeleton.Avatar {...props} active />;
};

AntSekelton.Input = (props) => {
  return <Skeleton.Input {...props} active />;
};

AntSekelton.Image = (props) => {
  return <Skeleton.Image {...props} active />;
};

AntSekelton.Node = (props) => {
  return <Skeleton.Node {...props} active />;
};

AntSekelton.Text = (props) => {
  return (
    <Skeleton.Node
      {...props}
      style={{ width: "100%", height: "12px", minWidth: "100px" }}
      active
    />
  );
};
